import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import WallCleaningQuote from "./sections/WallCleaningQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { Sparkles, Leaf, CloudRain, House, BrickWall, Layers } from "lucide-react";
const subServices = [{
  title: "High-Pressure Washing",
  description: "Deep cleaning services removing dirt, algae, and grime from durable brick and stone walls.",
  icon: Sparkles,
  to: "/PowerWashingPage"
}, {
  title: "Algae Removal",
  description: "Specialist biocide treatment eliminating and preventing organic regrowth on external masonry.",
  icon: Leaf
}, {
  title: "Soft Wash Systems",
  description: "Gentle low-pressure chemical cleaning tailored for delicate surfaces, modern coatings, and aged stone.",
  icon: CloudRain
}, {
  title: "Render Cleaning",
  description: "Safe, non-abrasive cleaning specifically formulated for rendered and cement finishes without scarring.",
  icon: House
}, {
  title: "Brick & Stone Restoration",
  description: "Restoring natural character and original appearance to historic and residential masonry.",
  icon: BrickWall,
  to: "/RePointingServicesPage"
}, {
  title: "Driveway & Patio Walls",
  description: "Comprehensive perimeter wall and retaining wall cleaning to match surrounding paved areas.",
  icon: Layers,
  to: "/DrivewayServicesPage"
}, {
  title: "Commercial Facades",
  description: "Large-scale exterior cladding and commercial boundary wall maintenance solutions.",
  icon: House
}, {
  title: "Protective Sealing",
  description: "Long-term hydrophobic weatherproofing and breathable masonry protection for all wall types.",
  icon: Sparkles
}, {
  title: "Graffiti Removal",
  description: "Rapid-response masonry-safe cleaning to eliminate paint, ink, and staining from surfaces.",
  icon: Layers
}, {
  title: "Moss Treatment",
  description: "Targeted fungicidal removal and prevention on shaded exterior walls and damp boundary lines.",
  icon: Leaf
}, {
  title: "Heritage Cleaning",
  description: "Specialist non-destructive conservation care for period properties and listed boundary walls.",
  icon: BrickWall
}, {
  title: "Stain Removal",
  description: "Precision extraction of rust streaks, efflorescence, atmospheric carbon deposits, and oil stains.",
  icon: CloudRain
}];
export default function WallCleaningServicesPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Wall Cleaning" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Wall Cleaning in Southampton" intro="Professional exterior wall cleaning, render washing, and masonry restoration for homeowners and commercial properties across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/wall_cleaning_before_after.png" imageAlt="Professional before and after exterior wall cleaning demonstration on a Southampton property" actions={true} />

      <ServiceIntro eyebrow="EXPERT EXTERIOR MAINTENANCE" heading="Professional Wall Cleaning & Render Care in Southampton" paragraphs={["Protect your property with professional wall cleaning and roofing services in Southampton, Hampshire & surrounding areas. Our expert team removes algae, moss, atmospheric carbon, and weather staining, restoring brick, stone, and render to pristine condition.", "From heritage brickwork in Romsey to modern rendered homes in Shirley and Ocean Village, we combine regulated pressure cleaning with gentle soft wash treatments to clean safely without scarring surfaces or disturbing pointing."]} benefits={["Specialist soft wash and temperature-controlled cleaning systems for Southampton homes", "Effective removal of red and green algae, moss, lichen, and atmospheric pollution", "Safe treatments for K-Rend, delicate render, heritage brickwork, and stone facades"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/exterior-house-looking-clean.jpg?v=tgac5ua7he8" imageAlt="Clean and restored exterior residential house wall in Southampton by Firststop Roofing Ltd" cta={true} />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our Southampton Wall Cleaning Services" intro="Comprehensive exterior wall and render maintenance solutions tailored to protect and restore your property in Southampton, Hampshire & surrounding areas." items={subServices} columns={3} />

      <WallCleaningQuote />

      <OtherServices currentKey="wall-cleaning" />

      <CtaBand />

      <Footer />
    </div>;
}